import React from 'react';
import OtkCompanyProgressiveList from './OtkCompanyProgressiveList';
import { OTK_COMPANY_LIST_MASKS } from '../../../utils/otkCompanyListMasks';

export default function OtkCompanyCardList(props) {
  return <OtkCompanyProgressiveList mask={OTK_COMPANY_LIST_MASKS.cards} {...props} />;
}
